import { useState } from "react";
import { useDebouncedValue } from "@mantine/hooks";
export const usePageSearch = (debounceMs = 300) => {
    const [search, setSearch] = useState("");
    const [debouncedSearch] = useDebouncedValue(search, debounceMs);
    return {
        search,
        setSearch,
        debouncedSearch
    };
};
